<section class="bn-credit-report" aria-labelledby="bn-credit-report-title">
  <header class="bn-credit-report__header">
    <div class="bn-credit-report__heading">
      <i class="pi pi-shield" aria-hidden="true"></i>
      <div>
        <h2 id="bn-credit-report-title">Credit report</h2>
        <p>View-only report for the selected client</p>
      </div>
    </div>
    <div class="bn-credit-report__search" role="search">
      <span class="bn-credit-report__search-field">
        <i class="pi pi-search" aria-hidden="true"></i>
        <input
          pInputText
          type="search"
          aria-label="Search credit report"
          placeholder="Search report"
          autocomplete="off"
          [value]="searchQuery()"
          [disabled]="loading() || error()"
          (input)="queueSearch($any($event.target).value)"
          (keydown.enter)="nextMatch()"
        />
      </span>
      <span
        class="bn-credit-report__search-status"
        role="status"
        aria-live="polite"
      >
        {{ searchStatus() }}
      </span>
      <p-button
        icon="pi pi-chevron-up"
        severity="secondary"
        [text]="true"
        [rounded]="true"
        [disabled]="!hasSearchMatches()"
        ariaLabel="Previous search result"
        (onClick)="previousMatch()"
      />
      <p-button
        icon="pi pi-chevron-down"
        severity="secondary"
        [text]="true"
        [rounded]="true"
        [disabled]="!hasSearchMatches()"
        ariaLabel="Next search result"
        (onClick)="nextMatch()"
      />
    </div>
    <p-button
      icon="pi pi-times"
      severity="secondary"
      [text]="true"
      [rounded]="true"
      ariaLabel="Close credit report"
      (onClick)="close()"
    />
  </header>

  <div class="bn-credit-report__body">
    @if (loading()) {
      <div class="bn-credit-report__loading" role="status">
        <i class="pi pi-spinner pi-spin" aria-hidden="true"></i>
        Rendering credit report…
      </div>
    }
    @if (error()) {
      <p class="bn-credit-report__error" role="alert">
        We couldn't display this credit report.
      </p>
    }
    <div
      #pages
      class="bn-credit-report__pages"
      aria-label="Client credit report"
      [attr.aria-busy]="loading()"
    ></div>
  </div>
</section>
